import React from 'react';

const Price = ({ price }) => {
  const numberPrice = Number(price);
  return (
    <div>
      {numberPrice.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })}
    </div>
  );
};

export default Price;
